import { FormControl } from '@angular/forms';

export function multiSelectRangeValidator(
  minValue: number,
  maxValue: number
): Function {
  return function validateMultiSelectRange(formControl: FormControl): any {
    const error: any = {
      rangeError: {
        given: formControl.value,
        max: maxValue,
        min: minValue
      }
    };
    let length = 0;
    if (formControl.value != null) {
      length = formControl.value.length;
    }

    return (maxValue != null ? length > +maxValue : false) ||
      (minValue != null ? length < +minValue : false)
      ? error
      : null;
  };
}
